import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPrizeWallHeaderImage } from '../../state/prizeWall/prizeWall.slice';
import { PrizeWallHeaderProps } from './PrizeWallHeader.types';
import PrizeWallHeaderBase from '../common/PrizeWallHeaderBase/PrizeWallHeaderBase';
import PrizeWallTokensInfo from '../PrizeWallTokensInfo/PrizeWallTokensInfo';
import PrizeWallImage from '../common/PrizeWallImage/PrizeWallImage';
import PrizeWallHeaderImageSkeleton from './PrizeWallHeaderImageSkeleton/PrizeWallHeaderImageSkeleton';

function PrizeWallHeader(props: PrizeWallHeaderProps) {
  const headerImage = useSelector(selectPrizeWallHeaderImage);

  return (
    <PrizeWallHeaderBase {...props}>
      {headerImage ? (
        <PrizeWallImage
          {...headerImage}
          marginHorizontal="auto"
          width={160}
          height={40}
        />
      ) : (
        <PrizeWallHeaderImageSkeleton />
      )}
      <PrizeWallTokensInfo />
    </PrizeWallHeaderBase>
  );
}

export default memo(PrizeWallHeader);
